"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawBorder = exports.createPolygon = exports.p = exports.pixelize = void 0;
const pixelize = (val) => val ? `${parseInt(String(val))}px` : '0px';
exports.pixelize = pixelize;
exports.p = exports.pixelize;
const createPolygon = ({ afterStyles, childStyles, beforeStyles, bgcolor = 'background.paper', borderColor = 'border', rootStyles, strokeWidth = 1, }) => {
    return Object.assign(Object.assign({ position: 'relative' }, rootStyles), { '& > *:not(.MuiAutocomplete-loading):first-of-type': Object.assign({}, childStyles), '& > *:first-of-type': {
            '&:before': Object.assign({ backgroundColor: borderColor, bottom: 0, content: '""', left: 0, position: 'absolute', right: 0, top: 0, zIndex: -2 }, beforeStyles),
            '&:after': Object.assign({ backgroundColor: bgcolor, bottom: strokeWidth, content: '""', left: strokeWidth, overflow: 'hidden', position: 'absolute', right: strokeWidth, top: strokeWidth, zIndex: -1 }, afterStyles),
        } });
};
exports.createPolygon = createPolygon;
const drawBorder = ({ color, focusColor }) => {
    return {
        backgroundColor: 'transparent',
        backgroundImage: 'none',
        borderBottom: '1px solid',
        borderBottomColor: color,
        // Highlight bottom border — initially left positioned to 50%, but once
        // the Select is open the line is moved to left position 0. The transition
        // moves the line to the left appearing as if the line expands out to the
        // right and left. This alleviates the need for a "border" element in the
        // Select component.
        '&:before': {
            backgroundColor: focusColor,
            bottom: 0,
            content: '" "',
            height: 1,
            left: '50%',
            position: 'absolute',
            transition: 'all 0.3s ease-in-out',
            width: 0,
        },
        // Use :has selector and aria-expanded attribute to determine whether the
        // input menu is open.
        '&:has(*[aria-expanded="true"]), &.Mui-focused': {
            '&:before': {
                left: 0,
                width: '100%',
            },
            '&:after': {
                backgroundColor: focusColor,
            },
        },
    };
};
exports.drawBorder = drawBorder;
